import React from 'react'

const Data = () => {
  return (
    <div className="home__data">
      <h1 className="home__title">
        Siddiq Odiq
      </h1>
      <h3 className="home__subtitle">
        Security Engineer & Web Developer
      </h3>
      <p className="home__description">
        I am a security engineer specializing in web security, while staying deeply passionate about exploring and applying Artificial Intelligence.
      </p>
    </div>
  )
}

export default Data